export default "/static/ot_temp_tiny.png";